<template>
	<v-dialog
		v-model="open"
		width="500"
	>
		<template #activator="{ props }">
			<slot
				name="activator"
				v-bind="props"
			/>
		</template>
		<v-card>
			<v-card-title>
				{{ title }}
			</v-card-title>
			<v-card-text>
				<v-form>
					<v-row>
						<v-col>
							<v-text-field
								v-model:model-value="editedSupplier.serviceCenter"
								variant="outlined"
								:label="$gettext('Service Center')"
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<country-select
								v-model:model-value="editedSupplier.countryId"
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<tax-type-select
								v-model:tax-type="editedSupplier.taxtypeId"
							/>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn
					variant="text"
					color="error"
					@click="open = false"
				>
					<translate>
						Cancel
					</translate>
				</v-btn>
				<v-btn
					variant="text"
					color="primary"
					@click="save"
				>
					<translate>
						Save
					</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import CountrySelect from '../atoms/CountrySelect.vue';

export default {
	name: 'SuppliersDialog',
	components: {
		CountrySelect
	},

	props: {
		supplier: {
			type: Object,
			required: false,
			default: () => {
				return {
					serviceCenter: null,
					taxtypeId: null,
					countryId: null,
				};
			}
		}
	},

	emits: ['update:supplier',],

	data () {
		return {
			open: false,
			editedSupplier: {
				...this.supplier
			},
			title: this.supplier.serviceCenter || this.$gettext('New Supplier')
		};
	},

	methods: {
		/**
		 * Update or create new supplier
		 */
		async save () {
			if (this.editedSupplier.id) {
				await axios.put(`/api/v0/suppliers/${this.supplier.id}`, {
					countryId: this.editedSupplier.countryId,
					taxtypeId: this.editedSupplier.taxtypeId,
					taxrateId: this.editedSupplier.taxrateId,
				});
			} else {
				await axios.post('/api/v0/suppliers', this.editedSupplier);
			}
			this.open = false;
			this.title = this.editedSupplier.serviceCenter;
			this.$emit('update:supplier', this.editedSupplier);
		}
	}
};
</script>

<style scoped>

</style>
